<template>
  <div class="pwd-retrieve customer-common">
    <div class="retr-head">
      <div :class="['step-1', step === 0 ? 'active' : '']">1.验证手机号码</div>
      <div :class="['step-2', step === 1 ? 'active' : '']">2.设置新密码</div>
    </div>
    <div class="container cus-style">
      <div v-if="!step">
        <div class="input">
          <van-field
            class="inputPhone"
            v-model="phone"
            center
            clearable
            maxlength="11"
            placeholder="请输入手机号"
            :error="validate.reg_verify_err.phone"
            @change="gettel('phone')"
          >
            <template #button>
              <van-popover v-model="showPopover" trigger="click" :actions="actions" @select="onSelect">
                <template #reference>
                  <div class="overallbaseline arrowBox">
                    <div>{{actionsValue}}</div>
                    <img class="arrow" :style="showPopover?'':'transform:rotate(-90deg)'" :src="require('../../assets/images/arrow.png')" alt="">
                  </div>
                </template>
              </van-popover>
            </template>
          </van-field>
          <van-field
            v-model="code"
            center
            clearable
            placeholder="请输入验证码"
            type="digit"
            max-length="6"
            :error="validate.reg_verify_err.code"
            @change="validate.code('code')"
          >
            <template #button>
              <span
                size="small"
                round
                @click="sendCode"
                style="color: #6cdd8f"
                >{{ sendClip ? "发送验证码" : `${second}s` }}</span
              >
            </template>
          </van-field>
        </div>
        <div class="next-btn">
          <van-button
            size="large"
            color="linear-gradient(to right, #5DD682, #5AFF8E)"
            @click="netxStep"
            >下一步</van-button
          >
        </div>
      </div>
      <div v-else>
        <div class="input">
          <van-field
            v-model="pwd"
            type="password"
            center
            clearable
            placeholder="请设置6-16位登录密码"
            :error="validate.reg_verify_err.pwd"
            @change="validate.pwd('pwd')"
          >
            <!-- <div slot="left-icon" class="inp-ico pwd-ico"></div> -->
          </van-field>
          <van-field
            v-model="rpwd"
            type="password"
            center
            clearable
            placeholder="请再次确认登录密码"
            :error="validate.reg_verify_err.rpwd"
            @change="validate.rpwd('pwd', 'rpwd')"
          >
            <!-- <div slot="left-icon" class="inp-ico pwd-ico"></div> -->
          </van-field>
        </div>
        <div class="next-btn">
          <van-button
            size="large"
            color="linear-gradient(to right, #5DD682, #5AFF8E)"
            @click="submitReset"
            >完成</van-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { updPassGetTelCode, updPass } from "@/utils/api/user";
import { validate } from "@/utils/mixin/validate";
export default {
  mixins: [validate],
  data() {
    return {
      phone: "",
      code: "",
      step: 0,
      pwd: "",
      rpwd: "",
      sendClip: true,
      itv: null,
      second: 60,

      showPopover:false,
      actions: [
        { text: '中国大陆+86',value:86 }, 
        { text: '中国香港+852',value:852 }, 
        { text: '中国澳门+853',value:852 }, 
      ],
      actionsValue:'中国大陆+86'
    };
  },
  methods: {
    onSelect(action) {
      this.actionsValue = action.text;
      this.phone = '';
    },
    gettel(key){
      let val = this[key];
      if (this.validate.formDataKey) {
        val = this[this.validate.formDataKey][key];
      }
      let res = '';
      if(this.actionsValue == '中国香港+852' || this.actionsValue == '中国澳门+853'){
        res = val.length == 8;
      }else{
        res = val.length == 11;
      }
      if (!res) {
        this.validate.reg_verify_err_msg[key] = `请输入正确的手机号`;
        this.$toast.fail("请输入正确的手机号");
      } else {
        this.validate.reg_verify_err_msg[key] = "";
      }
      this.validate.reg_verify_err[key] = !res;
      this.$forceUpdate();
      return res;
    },
    // 发送验证码
    sendCode() {
      if (!this.sendClip) {
        return;
      }
      const res = this.gettel("phone");
      if (!res) {
        this.$root.$toast.fail("请输入正确的手机号码！");
        return;
      }
      let phone = this.phone;
      if( this.actionsValue == '中国香港+852'){
        phone = '852' + this.phone;
      }
      if( this.actionsValue =='中国澳门+853'){
        phone = '853' + this.phone;
      }
      updPassGetTelCode(phone).then((res) => {
        if (res.success) {
          this.sendClip = false;
          this.codeInterval();
        }
      });
    },
    // 倒计时
    codeInterval() {
      this.itv = setInterval(() => {
        this.second--;
        if (!this.second) {
          this.second = 60;
          this.sendClip = true;
          window.clearInterval(this.itv);
        }
      }, 1000);
    },
    // 下一步
    netxStep() {
      let res = this.gettel("phone");
      if (!res) {
        this.$root.$toast.fail("请输入正确的手机号码！");
        return;
      }
      res = this.validate.code("code");
      if (!res) {
        this.$root.$toast.fail(this.validate.reg_verify_err_msg.code);
        return;
      }
      this.step++;
    },
    // 提交新密码跳转登录页面
    submitReset() {
      const res = this.gettel("phone");
      if (!res) {
        this.$root.$toast.fail("请输入正确的手机号码！");
        return;
      }
      if (this.pwd !== this.rpwd) {
        this.$root.$toast.fail("两次输入的密码不一致");
        return;
      }
      let phone = this.phone;
      if( this.actionsValue == '中国香港+852'){
        phone = '852' + this.phone;
      }
      if( this.actionsValue =='中国澳门+853'){
        phone = '853' + this.phone;
      }
      updPass({
        code: phone,
        newPass: this.pwd,
        telCode: this.code
      }).then((res) => {
        if (res.success) {
          this.$root.$toast.success({
            message: "设置成功！",
            duration: 1500,
            onClose: () => {
              this.$router.push("/login");
              // this.$store.commit("setUserInfo", {});
              // const role = this.$store.state.role;
              // switch (role) {
              //   case 0:
              //     break;
              //   case 1:
              //     this.$router.push("/loginjudge");
              //     break;
              //   case 2:
              //     this.$router.push("/loginorg");
              //     break;
              //   case 3:
              //     this.$router.push("/loginchannel");
              //     break;
              //   default:
              //     this.$router.push("/loginchoice");
              //     break;
              // }
            }
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.pwd-retrieve {
  min-height: 100vh;
  min-width: 100vw;
  overflow: hidden;
  .retr-head {
    position: relative;
    height: 44px;
    border-bottom: 1px solid #f2f2f2;
    width: 100vw;
    & > div {
      position: absolute;
      height: 100%;
      width: 50%;
      text-align: center;
      font-size: 13px;
      color: #999;
      line-height: 46px;
    }
    .step-1 {
      z-index: 5;
      background-color: #fff;
      &::before {
        content: "";
        display: block;
        position: absolute;
        top: 0;
        right: -16px;
        width: 0;
        height: 0;
        border-top: 22px solid transparent;
        border-left: 16px solid #fff;
        border-bottom: 22px solid transparent;
        z-index: 2;
      }
      &.active {
        background-color: #fdfcfc;
        &::before {
          border-left: 16px solid #fdfcfc;
        }
      }
      &::after {
        content: "";
        display: block;
        position: absolute;
        top: 0;
        right: -17.5px;
        width: 0;
        height: 0;
        border-top: 22px solid transparent;
        border-left: 16px solid #f2f2f2;
        border-bottom: 22px solid transparent;
        z-index: 1;
      }
    }
    .step-2 {
      right: 0;
      z-index: 1;
      &.active {
        background-color: #fdfcfc;
      }
    }
  }
  .container {
    width: 335px;
    margin: 0 auto;
    margin-top: 20px;
    .input {
      width: 335px;
      overflow: hidden;
      border-radius: 5px;
      margin: 0 auto;
      .pwd-ico {
        background: url("../../assets/images/login/password.png") no-repeat;
      }
      .rpwd-ico {
        background: url("../../assets/images/login/password.png") no-repeat;
      }
      .phone-ico {
        background: url("../../assets/images/login/phone.png") no-repeat;
      }
      .mail-ico {
        background: url("../../assets/images/login/mail.png") no-repeat;
      }
      .inp-ico {
        width: 55px;
        height: 55px;
        background-size: 20px 20px;
        background-position: center center;
      }
    }
    .next-btn {
      margin-top: 20px;
      .van-button {
        border-radius: 16px;
        width: 254px;
        height: 32px;
      }
    }
  }
}
</style>
<style lang="scss">
@import "../../assets/css/customer.scss";
.inputPhone{
  .van-field__body{
    display: flex;
    flex-direction: row-reverse;
  }
  .van-field__button{
    padding-left:0px !important;
    padding-right:5px !important;
  }
  .arrowBox{
    width: 96px;
    min-width: 100PX;
  }
  .arrow{
    width: 8px !important;
    height: 8px !important;
    margin-left: 4px;
  }
}
</style>
